export const SET_SUCCESS_UPLOAD_STATUS = "SET_SUCCESS_UPLOAD_STATUS";
export const SET_ERROR_UPLOAD_STATUS = "SET_ERROR_UPLOAD_STATUS";
export const RESET_UPLOAD_STATUS = "RESET_UPLOAD_STATUS";
export const UPDATE_UPLOADED_FILE_NAME = "UPDATE_UPLOADED_FILE_NAME";
export const UPDATE_UPLOADED_FILE_STATE = "UPDATE_UPLOADED_FILE_STATE";
export const SET_FILE_UPLOADED_SUCCESSFULLY = "SET_FILE_UPLOADED_SUCCESSFULLY";
export const SET_FILE_UPLOAD_FAILURE = "SET_FILE_UPLOAD_FAILURE";
export const UPDATE_FLASHBAR_STATE = "UPDATE_FLASHBAR_STATE";
export const RESET_FLASHBAR_STATE = "RESET_FLASHBAR_STATE";